import axios from 'axios'
import { clone } from '@/util/libUtil.js'
import statesIds from '@/util/retailX/offerStates.js';

const state = {
    isLoading: false,
    seguimientoOfertasDetalle: [],
    seguimientoOfertasResumen: [],
    seguimientoOfertasOfertas: [],
    seguimientoOfertasSecond: [],
    tramitacionesOfertas: [],
    variablesGraphic: [],
    tickets: [],
    filters: [],
    dateFilter: {
        since: null,
        until: null,
    },
    offerDialog: {
        isOpen: false,
        offers: null,
        isLoading: false,
    },
    paths: {
        seguimientoOfertasDetalle: '/api/scraping/vodafone/management/seguimiento-ofertas-detalle',
        seguimientoOfertasResumen: '/api/scraping/vodafone/management/seguimiento-ofertas-resumen',
        seguimientoOfertasOfertas: '/api/scraping/vodafone/management/seguimiento-ofertas-ofertas',
        seguimientoOfertasSecond: '/api/scraping/vodafone/management/seguimiento-ofertas-second',
        tramitacionesOfertas: '/api/scraping/vodafone/management/tramitaciones-ofertas',
        variablesGraphic: '/api/scraping/vodafone/management/variables-graphic',
        tickets: '/api/scraping/vodafone/management/tickets',
        offerDetail: '/api/scraping/vodafone/management/offer-detail',
        downloadPdf: '/api/scraping/vodafone/management/download-pdf',
        offerDetailOffer: '/api/scraping/vodafone/management/offer-detail-offer',
        checkAccess: '/api/scraping/vodafone/management/check-access',
    }
}

const mutations = {
    isLoading(state, val) {
        state.isLoading = val
    },
    seguimientoOfertasDetalle(state, val) {
        state.seguimientoOfertasDetalle = val
    },
    seguimientoOfertasResumen(state, val) {
        state.seguimientoOfertasResumen = val
    },
    seguimientoOfertasOfertas(state, val) {
        state.seguimientoOfertasOfertas = val
    },
    seguimientoOfertasSecond(state, val) {
        state.seguimientoOfertasSecond = val
    },
    tramitacionesOfertas(state, val) {
        state.tramitacionesOfertas = val
    },
    variablesGraphic(state, val) {
        state.variablesGraphic = val
    },
    tickets(state, val) {
        state.tickets = val
    },
    offerDialog(state, val) {
        state.offerDialog = val
    },
    offerDialogOpen(state, val) {
        state.offerDialog.isOpen = val
    },
    offerDialogOffers(state, val) {
        state.offerDialog.offers = val
    },
    offerDialogIsLoading(state, val) {
        state.offerDialog.isLoading = val
    },
    filters(state, val) {
        state.filters = val
    },
    dateFilter(state, val) {
        state.dateFilter = val
    }
}

const actions = {
    // fetch in all endpoints and return the data in parallel
    async fetchAll({ state, getters, commit }) {
        commit('isLoading', true)
        console.log('fetchAll')
        const checkAccess = await axios.get(getters.getEndpointFromPath(state.paths.checkAccess))
        if (checkAccess.data) {
            await Promise.all([
                actions.fetchSeguimientoOfertasDetalle({ state, getters, commit }),
                actions.fetchSeguimientoOfertasResumen({ state, getters, commit }),
                actions.fetchSeguimientoOfertasOfertas({ state, getters, commit }),
                actions.fetchSeguimientoOfertasSecond({ state, getters, commit }),
                actions.fetchTramitacionesOfertas({ state, getters, commit }),
                actions.fetchVariablesGraphic({ state, getters, commit }),
                actions.fetchTickets({ state, getters, commit }),
            ])
        } else {
            console.log('No access')
            setTimeout(() => {
                actions.fetchAll({ state, getters, commit })
            }, 1000)
        }

        commit('isLoading', false)
    },
    async fetchSeguimientoOfertasDetalle({ state, getters, commit }) {
        commit('isLoading', true)
        const res = await axios.get(getters.getEndpointFromPath(state.paths.seguimientoOfertasDetalle), {
            params: {
                since: state.dateFilter.since,
                until: state.dateFilter.until,
            }
        })
        commit('seguimientoOfertasDetalle', res.data.data)
        commit('isLoading', false)
    },
    async fetchSeguimientoOfertasResumen({ state, getters, commit }) {
        commit('isLoading', true)
        const res = await axios.get(getters.getEndpointFromPath(state.paths.seguimientoOfertasResumen), {
            params: {
                since: state.dateFilter.since,
                until: state.dateFilter.until,
            }
        })
        commit('seguimientoOfertasResumen', res.data.data)
        commit('isLoading', false)
    },
    async fetchSeguimientoOfertasOfertas({ state, getters, commit }) {
        commit('isLoading', true)
        const res = await axios.get(getters.getEndpointFromPath(state.paths.seguimientoOfertasOfertas), {
            params: {
                since: state.dateFilter.since,
                until: state.dateFilter.until,
            }
        })
        commit('seguimientoOfertasOfertas', res.data.data)
        commit('isLoading', false)
    },
    async fetchSeguimientoOfertasSecond({ state, getters, commit }) {
        commit('isLoading', true)
        const res = await axios.get(getters.getEndpointFromPath(state.paths.seguimientoOfertasSecond), {
            params: {
                since: state.dateFilter.since,
                until: state.dateFilter.until,
            }
        })
        commit('seguimientoOfertasSecond', res.data.data)
        commit('isLoading', false)
    },
    async fetchTramitacionesOfertas({ state, getters, commit }) {
        commit('isLoading', true)
        const res = await axios.get(getters.getEndpointFromPath(state.paths.tramitacionesOfertas), {
            params: {
                since: state.dateFilter.since,
                until: state.dateFilter.until,
            }
        })
        commit('tramitacionesOfertas', res.data.data)
        commit('isLoading', false)
    },
    async fetchVariablesGraphic({ state, getters, commit }) {
        commit('isLoading', true)
        const res = await axios.get(getters.getEndpointFromPath(state.paths.variablesGraphic), {
            params: {
                since: state.dateFilter.since,
                until: state.dateFilter.until,
            }
        })
        commit('variablesGraphic', res.data.data)
        commit('isLoading', false)
    },
    async fetchOfferDetail({ state, getters, commit }, offerId) {
        // commit('isLoading', true)
        // call 'vodafone/management/offer-detail/<str:offerId>' with axios
        const res = await axios.get(getters.getEndpointFromPath(state.paths.offerDetail + '/' + offerId), {
            params: {
                since: state.dateFilter.since,
                until: state.dateFilter.until,
            }
        })
        commit('offerDialogOffers', res.data.data)
        // commit('isLoading', false)
    },
    async downloadPdfOffer({ state, getters, commit }, offerId) {
        const res = await axios.get(getters.getEndpointFromPath(state.paths.downloadPdf + '/' + offerId))
        return res.data
    },
    async offerDetailOffer({ state, getters, commit }, offerId) {
        const res = await axios.get(getters.getEndpointFromPath(state.paths.offerDetailOffer + '/' + offerId))
        return res.data
    },
    async fetchTickets({ state, getters, commit }) {
        commit('isLoading', true)
        const res = await axios.get(getters.getEndpointFromPath(state.paths.tickets), {
            params: {
                since: state.dateFilter.since,
                until: state.dateFilter.until,
            }
        })
        commit('tickets', res.data.data)
        commit('isLoading', false)
    }
}

const getters = {
    getFiltersByStatesId: (state) => {
        return state.filters.map(item => statesIds[item + 1]['text'])
    },
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}


